import React from "react";
import _ from "lodash";

import { motion } from "framer-motion/dist/framer-motion";
import eye from "assets/images/ct/they-know-eye.png";
import line from "assets/images/ct/question/que-line.png";
import dice from "assets/images/ct/question/dice-arrow.png";
import ansCircle from "assets/images/ct/selection-circle.png";
import searchIcon from "assets/images/ct/question/search-icon.png";
import {
  divVariants,
  fadeVariants,
  slide_bounce_down_variants,
  staticBounceVariants
} from "shared/components/animations";
import dice1 from "assets/images/ct/dice1.png";
import dice2 from "assets/images/ct/dice2.png";
import dice3 from "assets/images/ct/dice3.png";
import dice4 from "assets/images/ct/dice4.png";
import dice5 from "assets/images/ct/dice5.png";
import dice6 from "assets/images/ct/dice6.png";
import dicearrow from "assets/images/ct/dice-arrow.png";
const NonActivePlayerQuestion = ({
  isReaderPlayer,
  answers,
  category,
  question,
  correct_answer,
  dicedata,screens
}) => {
  const reader_instructions = _.get(
    screens,
    "4_question.reader.instructions",   

    "You're the interrogator. Read them the question and find out what they know."  );

  const diceValue = (type) => {
    switch (type) {
      case 1:
        return dice1;

      case 2:
        return dice2;
      case 3:
        return dice3;
      case 4:
        return dice4;
      case 5:
        return dice5;

      default:
        return dice6;
    }
  };

  return (
    <motion.div
      variants={divVariants}
      initial="hidden"
      animate="visible"
      exit="exit"
      className="ct-question"
    >
      <motion.div variants={fadeVariants} className="ct-question-type">
        <img src={eye} className="img-fluid" alt="" />
        <div className="type">
          <h2>{category}</h2>
          <img src={line} className="img-fluid underline" alt="" />
        </div>
        <div className="dice">
          <img src={diceValue(dicedata?.dice[0])} alt="dicesketch" />
          <img src={diceValue(dicedata?.dice[1])} alt="dicesketch" />
          <img src={dicearrow} className="dice-arrow" alt="dicearrow" />
        </div>
      </motion.div>

      {isReaderPlayer && (
        <motion.p variants={fadeVariants} className="question">
         {reader_instructions}
        </motion.p>
      )}
      <motion.div
        variants={slide_bounce_down_variants}
        className="options-wrapper"
      >
        <div className="option-type">
          <div className="green-bg">
            <h2>{category}</h2>
          </div>
        </div>
        <div className="options-card">
          <h3 className="que">{question}</h3>
          {answers?.map((value, key) => (
            <div className="option-box-bg">
              <p className="mb-0 ans">{`${key + 1}. ${value}`}</p>
              {key === correct_answer && isReaderPlayer && (
                <img
                  src={ansCircle}
                  className={`img-fluid ans-circle ${
                    value?.length > 60 ? "ans-circle2" : ""
                  }`}
                  alt=""
                />
              )}
            </div>
          ))}
        </div>
      </motion.div>
      {!isReaderPlayer && (
        <motion.div variants={staticBounceVariants} className="result-buttons">
          <button className="learn-btn">
            <img src={searchIcon} className="img-fluid" alt="" />
            <br />
            Learn the conspiracy!
          </button>
        </motion.div>
      )}
    </motion.div>
  );
};

export default NonActivePlayerQuestion;
